import { IProviderReviewOption, isProgramImpactOption } from 'models';

export function splitReviewOptions<T extends IProviderReviewOption>(options: T[]) {
    const reviewOptions = options.filter((option) => !isProgramImpactOption(option));
    return {
        positive: reviewOptions.filter((option) => option.is_positive),
        negative: reviewOptions.filter((option) => option.is_negative),
        neutral: reviewOptions.filter((option) => !option.is_positive && !option.is_negative),
        programImpact: options.filter(isProgramImpactOption),
    };
}
